import React, { useState, useEffect } from 'react';
import { useTranslate } from '@bynder/localization';

import { IconArrowRight, IconCart } from '@bynder/icons';
import { API } from '../../helpers/api';
import { Cart } from '../../types';
import { initBrandstoreFeed } from '../../legacy/legacy';

const initialCart: Cart = {
	items: [],
	isVATEnabled: false,
	totalPrice: '',
	isCartAvailable: false,
};

/*
 * Find the code caracters in a string (e.g. &#36;), extract the charcode (36) and converts it to it's equivalent char.
 */
export function decode(str: string) {
	return str.replace(/&#(\d+);/g, (_, charCode) => {
		return String.fromCharCode(charCode);
	});
}

/*
 * bynder-platform/bynder/modules/brandstore/views/store/cart/dropdown.cfm
 */
export function Brandstore() {
	const [cart, setCart] = useState<Cart>(initialCart);

	const { items } = cart;
	const { translate } = useTranslate();

	useEffect(() => {
		API.getBrandstoreCart().then((response: Cart) => {
			if (response.isCartAvailable) {
				setCart(response);
			}
		});

		initBrandstoreFeed();
	}, []);

	return (
		<li id="shoppingCart">
			<a href="#" className="admin-dropdown" tabIndex={-1}>
				<IconCart />
				{items.length > 0 && <span>{items.length}</span>}
			</a>

			<div className="activity-dropdown">
				<h2>{translate('brandstore.MyCart')}</h2>

				<ul className="single">
					{items.map((item) => {
						const showUploadedAssetThumb = item.hasAssets && item.uploadedAssetThumb;
						const showAssetThumb =
							item.hasAssets && !showUploadedAssetThumb && item.assetThumb;

						return (
							<li className="clearfix task-dropdown-item new-task">
								{showUploadedAssetThumb && (
									<img
										alt="thumbnail"
										src={item.uploadedAssetThumb}
										className="left uploaded-product-dropdown-thumb"
									/>
								)}

								{showAssetThumb && (
									<img alt="thumbnail" src={item.assetThumb} className="left" />
								)}

								<span className="left title">
									{item.name}
									<br />
									<small> {item.amount} x </small>
								</span>

								<span className="right price">{decode(item.price)}</span>
							</li>
						);
					})}

					{cart.items.length > 0 && (
						<li className="clearfix task-dropdown-item new-task">
							<h3 className="left">
								{translate('cart.total')}
								{cart.isVATEnabled && (
									<span className="include-vat"> {translate('includeVat')}</span>
								)}
							</h3>

							<h3 className="price right">
								<strong>{decode(cart.totalPrice)}</strong>
							</h3>
						</li>
					)}

					{items.length === 0 && (
						<li className="clearfix task-dropdown-item new-task">
							<span>{translate('cart.youHaveNoItems')}</span>
						</li>
					)}
				</ul>

				<div className="checkout-btn">
					{items.length > 0 && (
						<a href="/store/cart/list/" className="action-btn blue block btn-lg">
							{translate('cart.goToMy')}
							<IconArrowRight />
						</a>
					)}

					{items.length === 0 && (
						<a href="/store/list/" className="action-btn blue block btn-lg">
							{translate('brandstore.goTo')}
							<IconArrowRight />
						</a>
					)}
				</div>
			</div>
		</li>
	);
}
